import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-function',
  templateUrl: './function.component.html',
  styleUrls: ['./function.component.scss']
})
export class FunctionComponent implements OnInit, OnChanges {

  public formFunction: FormGroup;
  public list = [
    {description: 'split', name: 'Split', value: 0}, {description: 'concat', name: 'Concat', value: 1},
    {description: 'mapping', name: 'Mapping', value: 2}, {description: 'parse', name: 'Parse', value: 3},
    {description: 'substring', name: 'Substring', value: 4}
    ];
  @Input() dataField: any;
  @Output() emitDataFunct: EventEmitter<any> = new EventEmitter<any>();
  public sourceColumn = '';
  public concat: string;
  public action: any;
  constructor(private fb: FormBuilder) {
    this.createForm();
  }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataField'].currentValue) {
    }
  }

  /**
   * @Metodo createForm
   * @description para el formulario.
   * */
  createForm() {
    this.formFunction = this.fb.group(
      {
        name: ['', Validators.required],
        column: ['', Validators.required],
        parameters: '',
        values: ''
      }
    );
    this.setValidators();
  }

  /**
   * @Metodo validFormFunction
   * @description Verifica la valides del formulario segun componentes
   * */
  validFormFunction(event) {

  }

  setValidators() {
    let params: boolean;
    this.formFunction.get('name').valueChanges.subscribe( val => {
      this.sourceColumn = val;
      val !== 'mapping' ? params = true : params = false;
      this.setValidatorsParameters(params, val);
    });
  }

  setValidatorsParameters(params: boolean, val: string) {
    const column = this.formFunction.get('column');
    const parameters = this.formFunction.get('parameters');
    const values = this.formFunction.get('values');
    if (params) {
      parameters.setValidators([Validators.required]);
      parameters.patchValue('');
      values.setValidators(null);
      values.patchValue('');
    } else {
      values.setValidators([Validators.required]);
      values.patchValue('');
      parameters.setValidators(null);
      parameters.patchValue('');
    }
    if (val === 'concat') {
      column.setValidators(null);
      column.patchValue('');
    } else {
      column.setValidators([Validators.required]);
    }
    this.formFunction.updateValueAndValidity();
  }
  save() {
    const dataFunct = this.formFunction.getRawValue();
    this.emitDataFunct.emit(dataFunct);
  }

}




// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/function/function.component.ts